import {AfterContentInit, AfterViewChecked, AfterViewInit, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {GritFeature} from "../../../models/grit/grit.feature";
import {GritModel, GritOption, GritTableField} from "../../../models/grit/grit.model";
import {GritDynamicTableComponent} from "../grit-dynamic-table/grit-dynamic-table.component";
import {GritDynamicTableMode, GritDynamicTableType} from "../../../models/grit/grit.enums";
import {FeatureType} from "../../../models/EnumTypes";
import {DeviceModel, InterferenceTestDeviceModel} from "../../../models/grit/grit.device-model";
import {ReceiverModel} from "../../../models/grit/grit.receiver-model";
import {InterferenceTestModel} from "../../../models/grit/grit.interference-test-model";
import {RadarModel} from "../../../models/grit/grit.radar-model";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-grit-dynamic-table-features',
  templateUrl: './grit-dynamic-table-features.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: true,
  imports: [
    GritDynamicTableComponent,
  ]
})
export class GritDynamicTableFeaturesComponent {

  _features : GritFeature<GritModel<any>> [] = null
  _models : GritModel<any> [] = null

  entityName : string = ""
  tableConfiguration : GritOption<GritTableField<GritModel<any>>>[]

  @ViewChild(GritDynamicTableComponent) table : GritDynamicTableComponent

  @Input() selectAll: boolean = false;
  @Input() type: GritDynamicTableType = GritDynamicTableType.BASIC;
  @Input() mode: GritDynamicTableMode = GritDynamicTableMode.VIEW;
  @Input() pageSize: number = 10;

  @Output() selectedRowEvent = new EventEmitter<GritFeature<GritModel<any>>>();

  @Input({required: true}) set features(features : GritFeature<GritModel<any>>[]){
    if (features == null || features.length <= 0){
      this._features = features;
      this._models = features == null ? null : [];
      this.tableConfiguration = null;
      return;
    }

    let featureType = features[0].featureType;
    this.entityName = String(featureType);

    switch (featureType){
      case FeatureType.Device:
        this.tableConfiguration = InterferenceTestDeviceModel.configuration.table;
        break;
      case FeatureType.InterferenceTest:
        this.tableConfiguration = InterferenceTestModel.configuration.table;
        break;
      case FeatureType.Radar:
        this.tableConfiguration = RadarModel.configuration.table;
        break;
      default:
        this.tableConfiguration = null;
        return;
    }

    this._features = features;
    this._models = features.map(feature => feature.entity);
  }

  get selectedFeatures() {
    let modelsIds = this.table.selectedModels?.map(model => model.id);
    return this._features.filter(feature => modelsIds.includes(Number(feature.getId())));
  }


  modelToFeature(model : GritModel<any>){
    if (this.mode == GritDynamicTableMode.VIEW) return;
    this.selectedRowEvent.emit(this._features.find(feature => feature.getId() == model.id))
  }

}
